import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

const FFmpegContext = createContext();

export const FFmpegProvider = ({ children }) => {
    const ffmpegRef = useRef(new FFmpeg());

    const [ffmpeg, setFfmpeg] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {

        const loadFFmpeg = async () => {
            try {
                const baseURL = `${process.env.PUBLIC_URL || ''}`;
                const ffmpeg = ffmpegRef.current;
                ffmpeg.on('log', ({ message }) => {
                    console.log(message);
                });
                // toBlobURL is used to bypass CORS issue, urls with the same
                // domain can be used directly.
                await ffmpeg.load({
                    coreURL: `${baseURL}/ffmpeg-core.js`,
                    wasmURL: `${baseURL}/ffmpeg-core.wasm`,
                });
                setFfmpeg(ffmpeg);
                setIsLoaded(true);
            } catch (err) {
                setError(err);
            }
        };
        if (window.location.href.includes('/watch-me-grow') || window.location.href.includes('/child-journals/') || window.location.href.includes('/story/') || window.location.href.includes('/tell_a_story/'))
            loadFFmpeg();
        // Optionally, cleanup on unmount
        // return () => { ... }
    }, []);

    return (
        <FFmpegContext.Provider value={{ ffmpeg, isLoaded, error }}>
            {children}
        </FFmpegContext.Provider>
    );
};

export const useFFmpeg = () => useContext(FFmpegContext);